import { EventDateModel } from 'ts-core';
import dayjs from 'dayjs';

export function dateCountDown(
  date: EventDateModel,
  translated: (key: string) => string
) {
  const currentDate = new Date();
  const sBetweenDates =
    date.start.getTime() / 1000 - currentDate.getTime() / 1000;
  const days = Math.floor(sBetweenDates / (24 * 60 * 60));
  const daysS = sBetweenDates % (24 * 60 * 60);
  const hours = Math.floor(daysS / (60 * 60));
  const hoursS = sBetweenDates % (60 * 60);
  const minutes = Math.floor(hoursS / 60);

  if (sBetweenDates < 0) {
    if (
      date.end &&
      date.end!.getTime() / 1000 - currentDate.getTime() / 1000 < 0 &&
      !date.isFullDay
    ) {
      return translated('countdown_past');
    } else {
      if (translated('countdown_now') !== undefined) {
        return translated('countdown_now');
      }
      return `${translated('countdown_in')} ${0} ${translated(
        'countdown_minutes'
      )}`;
    }
  } else if (days === 1) {
    return `${translated('countdown_tomorrow')}`;
  } else if (days > 0) {
    return `${translated('countdown_in')} ${days} ${translated(
      'countdown_days'
    )}`;
  } else if (hours > 0 && days === 0) {
    return `${translated('countdown_in')} ${hours} ${translated(
      'countdown_hours'
    )}`;
  } else if (minutes > 0 && days === 0 && hours === 0) {
    return `${translated('countdown_in')} ${minutes} ${translated(
      'countdown_minutes'
    )}`;
  }
  
  // Fallback for events starting in less than a minute
  return translated('countdown_now') || `${translated('countdown_in')} ${0} ${translated('countdown_minutes')}`;
}
export const formatDate = (date: Date) => {
  if (!date) return '';
  return dayjs(date).format('DD.MM.YYYY HH:mm');
};
